module.exports = __webpack_public_path__ + "static/img-8-2981044891844ae4c83c3651f01774e6.jpg";